export const RespRateControllerFactory = ({
  respRateService,
}: {
  respRateService: IRespRateService;
}) => {
  const getRespRate: IGetRespRate = async (payload) => {
    // Add BL here...
    const response = await respRateService.getRespRate(payload);
    return response;
  };

  return {
    getRespRate,
  };
};
